<template>
  <Teleport to="body">
    <div v-if="modelValue" class="fixed inset-0 z-50 overflow-hidden">
      <div class="absolute inset-0 bg-slate-900/40" @click="emit('update:modelValue', false)"></div>
      <section
        ref="panelRef"
        role="dialog"
        aria-modal="true"
        :aria-label="title"
        tabindex="-1"
        class="absolute right-0 top-0 flex h-full w-full max-w-5xl flex-col bg-white shadow-xl"
      >
        <header class="flex items-center justify-between border-b border-slate-200 px-6 py-4">
          <div class="min-w-0">
            <h3 class="truncate text-lg font-semibold text-slate-900">{{ title }}</h3>
            <p v-if="subtitle" class="mt-1 truncate text-sm text-slate-500">{{ subtitle }}</p>
          </div>
          <button type="button" class="rounded-md p-1.5 text-slate-400 hover:bg-slate-100 hover:text-slate-600" @click="emit('update:modelValue', false)">
            <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </header>
        <main class="min-h-0 flex-1 overflow-y-auto p-6">
          <slot />
        </main>
        <footer v-if="$slots.footer" class="border-t border-slate-200 px-6 py-4">
          <slot name="footer" />
        </footer>
      </section>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, toRef } from 'vue'
import { useModalA11y } from '@/composables/useModalA11y'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: '详情'
  },
  subtitle: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update:modelValue'])

const panelRef = ref(null)
useModalA11y(toRef(props, 'modelValue'), panelRef, () => emit('update:modelValue', false))
</script>
